import { useEffect, useState } from 'react';
import { CaretUp } from '@phosphor-icons/react';
import { useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';

/**
 * Drijvende "terug naar boven"-knop die verschijnt wanneer de gebruiker voorbij een
 * bepaalde scroll-positie is. Werkt op zowel window-scroll als op de app-content
 * container (Layout gebruikt overflow-auto op een interne div).
 */
export default function ScrollToTopFAB({ threshold = 400 }) {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    // Luister naar scroll-events op zowel window als op het <main> element (Layout gebruikt
    // overflow-y-auto op main). Door beide te bewaken werkt de FAB overal.
    const mainEl = document.querySelector('main');
    const getY = () => {
      const m = mainEl?.scrollTop || 0;
      const w = window.scrollY || document.documentElement.scrollTop || 0;
      return Math.max(m, w);
    };
    const onScroll = () => setVisible(getY() > threshold);
    mainEl?.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => {
      mainEl?.removeEventListener('scroll', onScroll);
      window.removeEventListener('scroll', onScroll);
    };
  }, [threshold]);

  const naarBoven = () => {
    const main = document.querySelector('main');
    if (main && main.scrollTop > 0) main.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;
  if (pathname === '/facturen') {
    const slot = document.querySelector('[data-testid="invoice-back-to-top-slot"]');
    return slot ? createPortal(<button type="button" onClick={naarBoven} className="inline-flex items-center gap-1 text-xs text-blue-800 px-3 py-2 hover:bg-blue-50" data-testid="invoice-back-to-top"><CaretUp size={14} />Terug naar boven</button>, slot) : null;
  }
  return (
    <button
      type="button"
      onClick={naarBoven}
      className="fixed z-50 shadow-xl bg-[#002FA7] text-white hover:bg-[#1E40AF] active:scale-95 transition-all rounded-full flex items-center justify-center"
      style={{ bottom: '84px', right: '20px', width: '48px', height: '48px' }}
      aria-label="Terug naar boven"
      title="Terug naar boven"
      data-testid="scroll-to-top-fab"
    >
      <CaretUp size={22} weight="bold" />
    </button>
  );
}
